import React from 'react';
import {AddButton} from '../../atoms/ContainedButton/index';
import style from './style';

function Presenter({placeholder,disabled,value,onKeyPress,onChange,onBlur,onAddClick,...props}){
	return (
		<style.Wrapper {...props}>
			<style.TextInput
				value={value}
				placeholder={placeholder}
				onKeyPress={onKeyPress} 
				onChange={onChange}
				onBlur={onBlur}
				disabled={disabled}
			/>
			<AddButton onClick={onAddClick} disabled={disabled}>
				<style.PlusIcon/>
			</AddButton>
		</style.Wrapper>
	);
}


export default Presenter;